
import { Injectable } from '@angular/core';
// import * as $ from 'bootstrap-notify/bootstrap-notify'
declare var $:any;
@Injectable()
export class NotificationService {
  notification;
  notificationConfig={ 
    "z_index": 2000, 
    "delay": 10000, 
    "mouse_over": "pause",
    "offset.x": 174,
    "offset.y": 97
    };
  constructor() { 
    $.notifyDefaults(this.notificationConfig);
  }
  notifySuccess(message){
    let configuration = {};
         configuration['options'] = {
             "message":  '<i class="fa fa-check"></i><span class="msg">'+message+'</span>'
         };
         configuration['settings'] = {
               "type":"success",
               "newest_on_top": true
         };
         $.notifyClose();
        setTimeout(()=>this.notification=$.notify(configuration['options'],configuration['settings']),600) ;
        
  }
  notifyInfo(message){
    let configuration = {};
    configuration['options'] = {
        "message":  '<span class="msg">'+message+'</span>'
    };
    configuration['settings'] = {
          "type":"info",
          "newest_on_top": true,
          "mouse_over": "pause",
          "allow_dismiss": true
    };
    $.notifyClose();
     setTimeout(()=>{this.notification=$.notify(configuration['options'],configuration['settings'])},600) ;
    
  }
  notifyDanger(message)
    {
        var configuration = {};
        configuration['options'] = {
            "message": '<i class="fa fa-exclamation"></i><span  class="msg">'+message+'</span>'                         
        };
        configuration['settings'] = {
            "type":"danger",
             "allow_dismiss": true,
            "mouse_over": "pause",
            "newest_on_top": true
        };
        $.notifyClose();
        setTimeout(()=>this.notification=$.notify(configuration['options'],configuration['settings']),600) ;
    };
}


